import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block3-ai智能问答.png")